import React from 'react';
import { connect } from 'react-redux';
import { Typography, Stack } from '@mui/material';
import DatePicker from 'react-multi-date-picker';
import BuildingSelector from '../buildingselector/BuildingSelector';
import BuildingMultiSelector from '../buildingselector/BuildingMultiSelector';

import './changelog-filter.css';

const ChangelogFilters = ({
  orgId,
  filters,
  setFilters,
  noDates = false,
  singleBuilding = false,
}) => (
  <Stack direction="row">
    <div className="changelog-filter">
      <Typography variant="h6">Building Selection:</Typography>
      {singleBuilding ? (
        <BuildingSelector
          selectedBuildingId={filters.buildings[0] ?? -1}
          orgId={orgId}
          handleSelection={(e) => setFilters({ ...filters, buildings: [e.target.value] })}
        />
      ) : (
        <BuildingMultiSelector
          selected={filters.buildings}
          orgId={orgId}
          onValueChange={(buildings) => setFilters({ ...filters, buildings })}
        />
      )}
    </div>
    {noDates ? null : (
      <div className="changelog-filter">
        <Typography variant="h6">Date Selection:</Typography>
        <DatePicker
          value={filters.date}
          maxDate={new Date()}
          onChange={(ts) => setFilters({ ...filters, date: new Date(ts) })}
        />
      </div>
    )}
  </Stack>
);

const mapStateToProps = (state) => {
  const {
    user: { orgId },
  } = state;
  return {
    orgId,
  };
};
export default connect(mapStateToProps)(ChangelogFilters);
